// extracted by css-extract-rspack-plugin
export default {"ContributorFooter":"ContributorFooter-module__ContributorFooter__pgye_","octicon":"ContributorFooter-module__octicon__Pko93"};